import { FunctionalComponent, h } from '@stencil/core';
import get from 'lodash/get'
import state from '../store/store'

import { AppMedia, AppRTE, AppLightbox } from './'

interface SectionProductGallery {
    __component?: string;
    data?: any;
}

export const SectionProductGallery: FunctionalComponent<SectionProductGallery> = ({ data }) => {

    const { Autoplay, Description, Feature, Gallery, Infinite, Tags } = data
    const GalleryItems = get(Gallery, 'data') || []
    const youtubeTest = ['youtu.be', 'youtube.com'];

    const getLightboxLink = (Media) => {
        return { Label: (get(state, 'website.VideosCTA') || 'Watch'), 'URL': get(Media, 'attributes.caption'), Icon: 'play' };
    }


    const getMediaImage = (media) => (
        <div class="uk-inline-clip uk-width-1-1 uk-height-medium uk-height-large@s" tabindex="0">
            <div class="uk-cover-container uk-width-1-1 uk-height-medium uk-height-large@s">
                <AppMedia media={media} size="(max-width: 638px) 80vw, (max-width: 958px) 50vw, 30vw" cover />
            </div>
            <div class="uk-light">
                {
                    <div class="uk-position-bottom-right uk-padding-remove uk-overlay">
                        <div class="wsio-grey-badge uk-margin-remove uk-text-small"><div>{(get(media, 'attributes.caption') || '').replace(/(.jpg|.jpeg|.png])/ig, '')}</div></div>
                    </div>
                }
            </div>
        </div>
    )

    const getMediaVideo = (media) => (
        <div class="uk-inline-clip uk-width-1-1 uk-height-medium uk-height-large@s" tabindex="0">
            <div uk-lightbox="video-autoplay=1;" class='uk-cover-container uk-width-1-1 uk-height-medium uk-height-large@s uk-height-medium@s uk-cover-container@s uk-width-1-1 uk-light uk-link-reset uk-transition-toggle uk-inline'>
                <AppLightbox className="uk-text-center wsio-link-hover" data={getLightboxLink(media)}>
                    <AppMedia media={media} className='uk-width-1-1 uk-transition-scale-up uk-transition-opaque' size="(max-width: 638px) 80vw, (max-width: 958px) 50vw, 30vw" cover />
                    <div class="uk-position-bottom-left uk-padding-small">
                        <div><span uk-icon="icon:play-circle; ratio:4;"></span></div>
                        <div>Watch Video</div>
                    </div>
                </AppLightbox>
            </div>
        </div>
    )

    return (
        <section class="uk-margin-medium-top ">
            <div>
                <div class="uk-container uk-margin-medium-bottom">
                    <div>
                        <ul class="wsio-quad-tag">
                            {Tags.data.map(({ attributes: { Label } }) => <li><span>{Label}</span></li>)}
                        </ul>
                    </div>
                    <AppRTE className='uk-margin-medium uk-heading-small' markdown={Description} />
                    <div>
                        <div class="uk-column-1-2@s uk-padding@s uk-padding-remove-vertical">
                            <ul class="uk-list uk-list-large uk-list-hyphen">
                                {Feature.map(({ Title }) => <li>{Title}</li>)}
                            </ul>
                        </div>
                    </div>
                </div>
                <div hidden={GalleryItems.length == 0} class="uk-margin uk-margin-large-top uk-container uk-container-large uk-margin-medium-bottom">
                    <div class="uk-width-1-1">
                        <div class="uk-position-relative" uk-slider={`finite: ${!Infinite}; ${Autoplay ? 'autoplay: false;"' : ''}`} >
                            <ul class="uk-slider-items uk-grid uk-grid-small">
                                {
                                    GalleryItems.map((media) =>
                                        <li class="uk-width-4-5 uk-width-2-3@s uk-width-3-5@m uk-width-2-5@l">
                                            {
                                                (get(media, 'attributes.caption') && youtubeTest.some(test => get(media, 'attributes.caption').includes(test))) ? getMediaVideo(media) : getMediaImage(media)
                                            }
                                        </li>
                                    )
                                }
                            </ul>
                            <div hidden={GalleryItems.length == 0} class="uk-margin-top uk-flex uk-flex-right" style={{ 'min-height': '34px' }}>
                                <a
                                    href="#" rel="nofollow"
                                    uk-slidenav-previous
                                    uk-slider-item="previous"
                                    aria-label="previous"
                                ></a>
                                <span class="uk-margin-right"></span>
                                <a
                                    href="#" rel="nofollow"
                                    uk-slidenav-next
                                    uk-slider-item="next"
                                    aria-label="next"
                                ></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
};